module.exports = __webpack_public_path__ + "static/media/how-bootcamps-boost-personality.3936bbf1.png";